import {
  ChromeExtensionMessages,
  NAVIGATE_ACTIVE_TAB_MIN_EXTENSION_VERSION
} from '@/constants/chromeExtension';

import bootChromeExtensionVersion from './bootChromeExtensionVersion';
import isInChromeExtension, { getChromeExtensionOrigin } from './isInChromeExtension';
import isVersionAtLeast from './isVersionAtLeast';

/**
 * Asks the Chrome extension to load the URL in the tab beside its side panel,
 * since sites like Healthie refuse to load inside the panel's iframe. Returns
 * false when there's no extension that can, so the caller opens it some other
 * way. The extension only accepts domains on its allowlist (see
 * ACTIVE_TAB_NAVIGATION_DOMAINS in extension/src/constants.ts).
 */
export default function navigateActiveTab(url: string): boolean {
  if (
    !isInChromeExtension() ||
    !isVersionAtLeast(bootChromeExtensionVersion, NAVIGATE_ACTIVE_TAB_MIN_EXTENSION_VERSION)
  )
    return false;

  window.parent.postMessage(
    { type: ChromeExtensionMessages.NAVIGATE_ACTIVE_TAB, url },
    getChromeExtensionOrigin()!
  );
  return true;
}
